<template>
    <footer class="footer">
      <div class="row col-md-7 mx-auto py-5">
        <div class="col-lg-3 col-sm-6 text-end my-1">
          <h6 style="font-weight: bold;">Services</h6>
          <div style="color: #7f7f7f;font-size: 15px;"><a href="../services/organizational-services" style="color: #7f7f7f;text-decoration: none;">Organizational</a></div>
          <div style="color: #7f7f7f;font-size: 15px;"><a href="../services/business-owner" style="color: #7f7f7f;text-decoration: none;">Business Owners</a></div>
          <div style="color: #7f7f7f;font-size: 15px;"><a href="../services/services-manufacturers" style="color: #7f7f7f;text-decoration: none;">manufacturers</a></div>
          <div style="color: #7f7f7f;font-size: 15px;"><a href="../services/merchant-services" style="color: #7f7f7f;text-decoration: none;">Merchants And Traders</a></div>
          <div style="color: #7f7f7f;font-size: 15px;"><a href="../services/traders-services" style="color: #7f7f7f;text-decoration: none;">Traders</a></div>
          <div style="color: #7f7f7f;font-size: 15px;"><a href="../services/technology-consulting-service" style="color: #7f7f7f;text-decoration: none;">Design Technology</a></div>
          <div style="color: #7f7f7f;font-size: 15px;"><a href="../services/data-management-service" style="color: #7f7f7f;text-decoration: none;">Data Management And Analysis</a></div>
        </div>
        <div class="col-lg-3 col-sm-6 text-end my-1">
          <h6 style="font-weight: bold;">Important Links</h6>
          <div style="color: #7f7f7f;font-size: 115x;"><a href="../tests" style="color: #7f7f7f;text-decoration: none;">Tests</a></div>
          <div style="color: #7f7f7f;font-size: 15px;"><a href="../trade/trade-assistant" style="color: #7f7f7f;text-decoration: none;">Trade assistant</a></div>
          <div style="color: #7f7f7f;font-size: 15px;"><a href="../report-view" style="color: #7f7f7f;text-decoration: none;">Reports</a></div>
        </div>
        <div class="col-lg-2 col-sm-3 text-end my-1">
          <h6 style="font-weight: bold;">Nabaco</h6>
          <div style="color: #7f7f7f;font-size: 15px;"><a href="../about" style="color: #7f7f7f;text-decoration: none;">About Us</a></div>
          <div style="color: #7f7f7f;font-size: 15px;"><a href="../contact" style="color: #7f7f7f;text-decoration: none;">Contact Us</a></div>
          <div style="color: #7f7f7f;font-size: 15px;"><a href="../vip-club" style="color: #7f7f7f;text-decoration: none;">VIP Club</a></div>
        </div>
        <div class="col-lg-2 col-sm-3 text-end my-1">
          <h6 style="font-weight: bold;">Contact</h6>
          <div style="color: #7f7f7f;font-size: 15px;">Support</div>
          <div style="color: #7f7f7f;font-size: 15px;">Email</div>
        </div>
        <div class="col-lg-2 col-sm-3 text-start pb-4 my-1">
          <div class="mt-4" style="color: #7f7f7f;font-size: 15px;">989192701407</div>
          <div style="color: #7f7f7f;font-size: 15px;">info.nabacoai@gmail.com</div>
        </div>
        <hr class="mt-3">
        <div class="row col-lg-7 col-sm-9 mt-4 mx-auto">
        <h3 style="font-weight: bold;">NABACO</h3>
        <!-- <h6 class="mt-3">در دنیای پیچیده‌ی بازارهای مالی، سرمایه‌گذاری هوشمندانه و موفق نیازمند اتکا به ابزارها و استراتژی‌های به روز است. شما با الگوراک سرمایه‌گذاری هوشمندانه و متفاوت در بازارهای مالی را به نوین‌ترین روش‌، تجربه خواهید کرد. الگوراک، فراتر از یک پلتفرم سرمایه‌گذاری است. ما با تعهد به ارائه خدمات باکیفیت و پشتیبانی همیشگی، در کنار شما خواهیم بود تا به اهداف مالی خود دست پیدا کنید.</h6> -->
        <h6 style="font-weight: bold;" class="mt-4">Follow us on social media</h6>
        <div class="my-auto px-lg-3 px-0 text-center d-block mt-4">
          <a class="footer-icon" href="https://t.me/XAIFIN"><FontAwesomeIcon icon="fa-brands fa-telegram"/></a>
          <a class="mx-4 footer-icon" href="https://x.com/xaifin_ai"><FontAwesomeIcon icon="fa-brands fa-twitter"/></a>
          <a class="footer-icon" href="https://www.instagram.com/nabaco.ai/"><FontAwesomeIcon icon="fa-brands fa-instagram"/></a>
        </div>
      </div>
      </div>
  </footer>
</template>
<script>
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTelegram , faTwitter, faInstagram} from "@fortawesome/free-brands-svg-icons";
import { faAngleLeft} from "@fortawesome/free-solid-svg-icons";

export default defineComponent({
  components:{FontAwesomeIcon},
    setup() {
      const router = useRouter()
      library.add(faTelegram,faTwitter,faInstagram,faAngleLeft)
        return {
          router
        }
    },
})
</script>
<style scoped>
*{
  direction: ltr;
}
.footer {
  border-top: solid 1px #ececec;
  font-size: 15px;
  text-align: center;
}
.footer-icon {
  color: #004e9c;
  font-size: 25px
}
</style>
